/* import __COLOCATED_TEMPLATE__ from './we-run-on-intercom.hbs'; */
import templateOnlyComponent from '@ember/component/template-only';
export default templateOnlyComponent();